class RestaurantSelection extends ViewBasic {
	constructor(options) {
		super(options);
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		this.$el.on('click', e => this.changeMenu(e));
	}

	removeEvents() {

	}

	changeMenu(e){
		if($('#site-main').hasClass('restaurant-menu')){
			e.preventDefault();
			window.location = $(e.currentTarget).attr('data-url');
		}
	}
}